import Api from "@/api/Api";
import { PublishmentOrder } from "@/interfaces/publishmentorder";
export default async function(
  publishmentOrder?: PublishmentOrder,
  name = "invoice"
) {
  if (!publishmentOrder) {
    return;
  }
  const api = Api.singleton();
  const blob = await api.call({
    method: "POST",
    resource: publishmentOrder["@id"] + "/invoice",
    asBlob: true
  });
  api.downloadAs(blob, name);
}
